import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { CognitoService } from './cognito.service';
import { Store } from '@ngrx/store';
import { loggedUserActions } from '../../store/logged_user/logged_user.actions';
import { User } from '../../models/user.model';
import { selectLoggedUser } from '../../store/logged_user/logged_user.selectors';

export const authGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  // const authService = inject(AuthService);
  const cognitoService = inject(CognitoService);

  // if (authService.currentUser.username === null) {
  //   router.navigate(['/auth/login']);
  // }

  // if(cognitoService.isUserLogged === false) {
  //   router.navigate(['/auth/login']);
  // }

  return cognitoService.getUser()
  .then(() => {
    return true;
  })
  .catch((err:any) => {
    console.log(err)
    router.navigate(['/auth/login']);
    return false;
  })

  // return true;
};

export const guestGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  // const authService = inject(AuthService);
  const cognitoService = inject(CognitoService);

  // if(authService.currentUser.username !== null) {
  //   router.navigate(['/bollette']);
  // }

  // if(cognitoService.isUserLogged) {
  //   router.navigate(['/bollette']);
  // }

  return cognitoService.getUser()
  .then(() => {
    router.navigate(['/bollette/estrazione-dati']);
    return false;
  })
  .catch((err:any) => {
    console.log(err)
    return true;
  })
}
